var _styled;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

// https://github.com/alphagov/govuk-frontend/blob/master/src/components/checkboxes/_checkboxes.scss
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { withWhiteSpace } from '@govuk-react/hoc';
import { YELLOW, BLACK } from 'govuk-colours';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
var StyledCheckbox = styled('label')({
  display: 'block',
  position: 'relative',
  padding: '0 0 0 38px'
});
var StyledInput = styled('input')({
  position: 'absolute',
  left: 0,
  top: 0,
  width: '38px',
  height: '38px',
  zIndex: 1,
  margin: 0,
  zoom: 1,
  opacity: 0,
  ':checked + span:after': {
    opacity: 1
  },
  ':focus + span:before': {
    boxShadow: "0 0 0 4px " + YELLOW
  }
}, function (_ref) {
  var disabled = _ref.disabled;
  return {
    cursor: disabled ? 'auto' : 'pointer',
    ' + span': {
      opacity: disabled ? '.4' : '1',
      pointerEvents: disabled ? 'none' : 'auto'
    }
  };
});
var StyledLabel = styled('span')((_styled = {
  fontFamily: NTA_LIGHT,
  fontWeight: 400,
  textTransform: 'none',
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_19,
  lineHeight: LINE_HEIGHT.SIZE_19
}, _styled.cursor = 'pointer', _styled.padding = '8px 10px 9px 12px', _styled.display = 'block', _styled.color = "" + BLACK, _styled['::before'] = {
  content: "''",
  display: 'block',
  border: "2px solid " + BLACK,
  background: 'transparent',
  width: '34px',
  height: '34px',
  position: 'absolute',
  top: 0,
  left: 0
}, _styled['::after'] = {
  content: "''",
  border: 'solid',
  borderWidth: '0 0 5px 5px',
  background: 'transparent',
  borderTopColor: 'transparent',
  width: '17px',
  height: '7px',
  position: 'absolute',
  top: '10px',
  left: '8px',
  transform: 'rotate(-45deg)',
  zoom: 1,
  opacity: 0
}, _styled));

var Checkbox = function Checkbox(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      inline = _ref2.inline,
      input = _objectWithoutProperties(_ref2, ["children", "className", "inline"]);

  return React.createElement(StyledCheckbox, {
    className: className,
    inline: inline
  }, React.createElement(StyledInput, _extends({
    type: "checkbox"
  }, input)), React.createElement(StyledLabel, null, children));
};

Checkbox.defaultProps = {
  className: undefined,
  inline: undefined
};
Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  inline: PropTypes.bool
} : {};
export default withWhiteSpace({
  marginBottom: 2
})(Checkbox);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/checkbox/es/index.js
// module id = 77
// module chunks = 0